var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ColumnBaseComponent } from '../../../../../items/columns/base/columnbase.component';
import { ColumnService } from '../../../../../items/columns/column/column.service';
import { ColumnBaseService } from '../../../../../items/columns/base/columnbase.service';
import { KtsDepartmentService } from './department.service';
import { ItemBase } from '../../../../../models/item/item-base';
var KtsDepartmentLabelComponent = /** @class */ (function (_super) {
    __extends(KtsDepartmentLabelComponent, _super);
    function KtsDepartmentLabelComponent(service, baseService, departmentService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.departmentService = departmentService;
        _this.cols = [];
        return _this;
    }
    KtsDepartmentLabelComponent.prototype.ngOnInit = function () {
        // super.ngOnInit();
    };
    KtsDepartmentLabelComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        this.cols = [];
        var departmentKey = jsonpath.value(this.col, '$.params.department.key') || '';
        var sectionKey = jsonpath.value(this.col, '$.params.section.key') || '';
        if (this.val[departmentKey]) {
            this.departmentService.setBaseUrl('/v1/gen/department-m-service?query={"orderByList":[{"name":"id","direction":"asc"}]}');
            this.departmentService.getRecord().subscribe(function (rec) {
                var departmentOptions = [];
                var sectionOptions = [];
                for (var _i = 0, _a = rec.items; _i < _a.length; _i++) {
                    var item = _a[_i];
                    var key = item.id.toString();
                    departmentOptions.push({ code: item.id, display: item.department_name });
                    for (var _b = 0, _c = item.section_m; _b < _c.length; _b++) {
                        var sec = _c[_b];
                        sectionOptions.push({ code: sec.id, display: sec.section_name });
                    }
                }
                _this.cols.push(_this.getCol(departmentKey, departmentOptions));
                if (_this.val[sectionKey]) {
                    _this.cols.push(Object.assign(new ItemBase(), { controlType: 'label', label: ', ' }));
                    _this.cols.push(_this.getCol(sectionKey, sectionOptions));
                }
            });
        }
    };
    KtsDepartmentLabelComponent.prototype.getCol = function (key, options) {
        return Object.assign(new ItemBase(), { key: key, controlType: 'select', params: { options: options } });
    };
    KtsDepartmentLabelComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-column-department-label',
                    template: '<ng-template ngFor let-c [ngForOf]="cols" let-idx="index"><column-formlabel [componentName]="componentName" [index]="index" [col]="c" [val]="val[c.key]" [msg]="msg"></column-formlabel></ng-template>'
                }] }
    ];
    /** @nocollapse */
    KtsDepartmentLabelComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: KtsDepartmentService }
    ]; };
    return KtsDepartmentLabelComponent;
}(ColumnBaseComponent));
export { KtsDepartmentLabelComponent };
//# sourceMappingURL=department-label.component.js.map